/** The screen rotations the on-device menu offers (degrees). The platform stores a number; an old device row may hold "90" or "90°". Anything else is 0. */
export const ROTATIONS = [0, 90, 180, 270];

export function normaliseRotation(value) {
  const n = typeof value === 'number' ? value : parseInt(String(value ?? '').replace('°', '').trim(), 10);
  return ROTATIONS.includes(n) ? n : 0;
}
